import type { Catalog } from '@/types';

export function fmtSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
  return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
}

export function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function fmtTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function productName(catalog: Catalog | null, id: string): string {
  return catalog?.products.find((p) => p.id === id)?.name ?? id;
}

export function entityName(catalog: Catalog | null, productId: string, entityId: string): string {
  const product = catalog?.products.find((p) => p.id === productId);
  return product?.entities.find((e) => e.id === entityId)?.name ?? entityId;
}

export function classificationName(catalog: Catalog | null, id: string): string {
  return catalog?.classifications.find((c) => c.id === id)?.name ?? id;
}

export function generateUploadId(): string {
  return `IN-${48200 + Math.floor(Math.random() * 9999)}`;
}
